import MailboxJunkEmailConfigurationOptions from 'owa-service/lib/contract/MailboxJunkEmailConfigurationOptions';
import store from '../store/store';

/**
 * Returns the mailbox junk email configuration object which is observable
 */
export default function getMailboxJunkEmailConfiguration(): MailboxJunkEmailConfigurationOptions {
    return store.mailboxJunkEmailConfiguration;
}
